import styled from "styled-components";

export const StyledButton = styled("button")<any>`
  background: ${(p) => p.color || "#123456"};
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border-radius: 10px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  border: 1px solid #123456;

  &:hover,
  &:active
   {
    color: #fff;
    border: 1px solid #02efee;
    background-color: #02efee;
  }
`;
